export var DriverCommand;
(function (DriverCommand) {
    DriverCommand["getConfig"] = "driver.get_config";
    DriverCommand["updateLogConfig"] = "driver.update_log_config";
    DriverCommand["getLogConfig"] = "driver.get_log_config";
    DriverCommand["enableStatistics"] = "driver.enable_statistics";
    DriverCommand["disableStatistics"] = "driver.disable_statistics";
    DriverCommand["isStatisticsEnabled"] = "driver.is_statistics_enabled";
    DriverCommand["startListeningLogs"] = "driver.start_listening_logs";
    DriverCommand["stopListeningLogs"] = "driver.stop_listening_logs";
    DriverCommand["checkForConfigUpdates"] = "driver.check_for_config_updates";
    DriverCommand["installConfigUpdate"] = "driver.install_config_update";
    DriverCommand["setPreferredScales"] = "driver.set_preferred_scales";
    DriverCommand["enableErrorReporting"] = "driver.enable_error_reporting";
    DriverCommand["softReset"] = "driver.soft_reset";
    DriverCommand["trySoftReset"] = "driver.try_soft_reset";
    DriverCommand["hardReset"] = "driver.hard_reset";
    DriverCommand["shutdown"] = "driver.shutdown";
    DriverCommand["updateOptions"] = "driver.update_options";
    DriverCommand["sendTestFrame"] = "driver.send_test_frame";
    // Schema version >= 41:
    DriverCommand["firmwareUpdateOTW"] = "driver.firmware_update_otw";
    // Schema version >= 41:
    DriverCommand["isOTWFirmwareUpdateInProgress"] = "driver.is_otw_firmware_update_in_progress";
    DriverCommand["softResetAndRestart"] = "driver.soft_reset_and_restart";
    DriverCommand["enterBootloader"] = "driver.enter_bootloader";
    DriverCommand["leaveBootloader"] = "driver.leave_bootloader";
    // CC version queries
    DriverCommand["getSupportedCCVersion"] = "driver.get_supported_cc_version";
    DriverCommand["getSafeCCVersion"] = "driver.get_safe_cc_version";
    // User agent
    DriverCommand["updateUserAgent"] = "driver.update_user_agent";
    // RSSI monitoring
    DriverCommand["enableFrequentRSSIMonitoring"] = "driver.enable_frequent_rssi_monitoring";
    DriverCommand["disableFrequentRSSIMonitoring"] = "driver.disable_frequent_rssi_monitoring";
})(DriverCommand || (DriverCommand = {}));
